import React, { useState } from 'react'
import { useAuth } from '../../providers/useAuth'
import { FormPageWrapper } from './FormPageWrapper'
import { FormMessage } from './FormMessage'
import { Button } from './Button'
import { FooterText } from './FooterText'
import { useForm } from 'react-hook-form'
import { InputField } from 'cwp-components/forms'

const ForgottenPasswordPage = () => {
  const { resetPassword } = useAuth()
  const [userError, setError] = useState<string | null>(null)
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError: setFieldError,
    trigger,
  } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onChange',
  })

  const onSubmit = (values) => {
    setError(null)
    resetPassword(
      { email: values.emailAddress },
      {
        onSuccess: () => {
          document.location.href = `/reset-password?email=${encodeURIComponent(
            values.emailAddress,
          )}`
        },
        onError: (error) => {
          setFieldError('emailAddress', {
            message: 'There is no account connected to this email',
          })
          console.error('forgot password failed', error)
        },
      },
    )
  }
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  return (
    <FormPageWrapper
      className={'w-full md:w-[84%] '}
      title='Forgotten Password'
    >
      <FormMessage type='error'>{userError}</FormMessage>
      <form
        className='space-y-6'
        onSubmit={handleSubmit(onSubmit)}
        autoComplete='off'
      >
        <div className='text-center text-[#0C5F71] mt-8'>
          Enter the email address connected to your account
        </div>

        <div className='grid md:grid-cols-3 gap-4'>
          <div className='flex flex-col col-span-3 item-center'>
            <InputField
              register={register}
              required={true}
              regexPattern={emailPattern}
              id='emailAddress'
              label='Email address'
              placeholder='Email address'
              errors={errors}
              errorMessage='Please enter an email connected to an account'
            />
          </div>
        </div>

        <Button
          type='submit'
          className='!w-[101px] !mx-auto mt-10 !mb-10'
          disabled={Object.keys(errors)?.length > 0}
        >
          Continue
        </Button>
        <FooterText
          text='Remember your password?'
          linkHref='./login'
          linkText='Sign in'
          textClassName='!text-[#6E7785]'
        />
      </form>
    </FormPageWrapper>
  )
}

export default ForgottenPasswordPage
